/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconClock = createReactComponent("clock", "IconClock", [
  ["path", { d: "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", key: "svg-0" }],
  ["path", { d: "M12 7v5l3 3", key: "svg-1" }]
]);

export { IconClock as default };
//# sourceMappingURL=IconClock.js.map
